export default __webpack_public_path__ + "static/media/waggle_how.fde70ede.png";